import * as React from 'react';
import { connect } from 'react-redux';
import KPBreadCrumb from '../KPBreadCrumb/KPBreadCrumb';
import { POLICY_DETAILS, DASHBOARD, FNOL } from '../../routes/routes';
import ClaimCapture from './ClaimCapture';
import NeedHelp from '../BaseTemplate/SSPCustomComponentLibrary/NeedHelp/NeedHelp';
import { navigateTo } from '../../actions/navigationActions';
import { showFnolCallMeModal } from '../../actions/modalActions';

class SubmitClaim extends React.Component<any, any> {

    constructor(props) {
        super(props);
        this.handleRedirect = this.handleRedirect.bind(this);
        this.handleCoverRedirect = this.handleCoverRedirect.bind(this);
        this.handleCallMeBack = this.handleCallMeBack.bind(this);
    }

    handleCallMeBack = async (e: any) => {
        this.props.handleCallMeBack();  
    }

    handleRedirect(destination) {
        this.props.redirectTo(destination);
    }

    handleCoverRedirect() {
        const isMobile = window.innerWidth <= 975;
        if (isMobile) {
            this.props.redirectTo(POLICY_DETAILS);
        }
    }

    //componentDidMount() {
    //    this.props.dispatchHideProfile();
    //}

    public render() {
        const { profile } = this.props;
        let BreadcrumbDetails = [{ destination: DASHBOARD, description: "Home" }, { destination: FNOL, description: "Claims" }]

        return (
            <div id="SubmitClaim">
                <KPBreadCrumb navList={BreadcrumbDetails} activePage="Submit a claim" />
                {profile.personalPolicies[0] !== undefined &&
                    <>
                    <div className="d-none d-sm-none d-md-none d-lg-block d-xl-block">
                        <div className="row ">
                            <div className="col-lg-4 col-12">
                                <div className="claims-block pb-3 mb-4">
                                    <div className="px-lg-3">
                                        <h3 className="Claims-title pt-2 mb-2">Submit a claim</h3>
                                        <p className="pColor mb-lg-1">Before we can look into your claim, we need a few details. Remember, incorrect info may influence the outcome of your claim</p>
                                    </div>
                                </div>
                                <NeedHelp
                                isContactUsWhatsAppBlock={false}
                                isClaims={true}
                                countryId={this.props.profile.countryId}
                                claimsEmail={this.props.ssp.claims_email}
                                contactUsTel={this.props.ssp.contactUs_tel}
                                handleCallMeBack={(e) => this.handleCallMeBack(e)}
                                />
                            </div>
                            <div className="col-lg-8 col-12">
                              <ClaimCapture />
                            </div>
                        </div>
                    </div>
                    <div className="d-block d-sm-block d-md-block d-lg-none d-xl-none">
                        <div className="claims-block pb-3 mb-4">
                            <div className="container">
                                <h3 className="Claims-title pt-2 mb-2">Submit a claim</h3>
                                <p className="pColor mb-lg-1">Before we can look into your claim, we need a few details. Remember, incorrect info may influence the outcome of your claim</p>
                            </div>
                        </div>
                        <div className="mb-4">
                            <ClaimCapture />
                        </div>
                        <NeedHelp
                               isContactUsWhatsAppBlock={false}
                                isClaims={true}
                                countryId={this.props.profile.countryId}
                                claimsEmail={this.props.ssp.claims_email}
                                contactUsTel={this.props.ssp.contactUs_tel}
                                handleCallMeBack={(e) => this.handleCallMeBack(e)}
                            />
                    </div>
                    </>
                }
            </div>
        );
    }
}
const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        claimSubmit: state.claimSubmit,
        ssp:state.ssp
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        //dispatchHideProfile: () => dispatch(hideMobileProfile()),
        redirectTo: (destination) => dispatch(navigateTo(destination)),
        handleCallMeBack: () => dispatch(showFnolCallMeModal()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SubmitClaim);